export enum UpdateState {
    Draft = 1,
    AwaitApproval = 2,
    Scheduled = 3,
    Running = 4,
    Canceled = 5,
    Error = 6,
    Done = 7,
};